export default __webpack_public_path__ + "static/media/Friction1AImg.48b41166.jpg";